import bind from 'bind-decorator';

import * as React from 'react';

export interface IKeysWrapperProps
{
    selected:any;
    data:Array<any>;
    onChange:(value:any, closePopover?:boolean) => void;
}

export interface IKeysWrapperState
{
}

export class CellSettingsSubMenuKeys extends React.Component<IKeysWrapperProps, IKeysWrapperState>
{
    private _element:HTMLElement = null;

    @bind
    private _onElementRef(element:HTMLDivElement):void
    {
        if( !element )
            return;

        this._element = element;
        element.focus();
    }

    public render()
    {
        return (
            <div
                onKeyDown={this._onKeyDown}
                ref={this._onElementRef}
                tabIndex={0}
            >
                {this.props.children}
            </div>
        );
    }

    @bind
    private _onChange(fontSize:number, closePopover:boolean = true):void
    {
        const {onChange} = this.props;
        onChange && onChange(fontSize, closePopover);
    }

    @bind
    private _onKeyDown(e:React.KeyboardEvent<HTMLDivElement>):void
    {
        if( e.keyCode === 13 ) // enter
        {
            e.stopPropagation();
            e.preventDefault();
            this._onChange(this._getSelectedItem(), true);
            return;
        }

        let delta = 0;

        if( e.keyCode === 38 ) delta = -1; // up
        if( e.keyCode === 40 ) delta = +1; // down

        if( !delta ) return;

        const {selected, data} = this.props;

        let selectedIndex = data.indexOf(selected);

        if( selectedIndex === -1 ) return; // ???

        selectedIndex += delta;

        if( selectedIndex > data.length - 1 ) selectedIndex = 0;
        if( selectedIndex < 0 ) selectedIndex = data.length - 1;

        this._onChange(data[selectedIndex], false);

        e.stopPropagation();
        e.preventDefault();
    }

    private _getSelectedItem():any
    {
        const {selected, data} = this.props;
        const selectedIndex = data.indexOf(selected);

        if( selectedIndex === -1 ) return null;

        return data[selectedIndex];
    }
}
